<template>
  <FormControl :title="title" :sub-title="subtitle">
    <div class="tldraw-wrapper relative w-full h-full">
      <div v-if="show" class="w-full h-full">
        <Tldraw :data="data" :onchange="updateModel" class="w-full h-full" />
      </div>
    </div>
  </FormControl>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { mountReactComponent } from '@/reactUtils';
import TldrawReactWrapper from '@/react_app/TldrawReactWrapper.tsx';
import FormControl from '@/components/utils/FormControl/FormControl.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  tldrawData: {
    type: Object,
    default: () => ({}),
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:modelValue', 'update:data']);

const data = ref({ document: {} });
const show = ref(false);
const modelOrigin = ref({});
const source = ref({});

onMounted(() => {
  source.value = props.tldrawData || {};
  data.value = JSON.parse(JSON.stringify(props.tldrawData || {}));

  if (Object.keys(props.modelValue).length > 0) {
    source.value = props.modelValue;
    modelOrigin.value = props.modelValue;
    data.value = JSON.parse(JSON.stringify(props.modelValue));
  }
  show.value = true;
});

watch(
  () => props.modelValue,
  () => {
    if (Object.keys(props.modelValue).length > 0) {
      data.value = JSON.parse(JSON.stringify(props.modelValue));
    }
  },
  { deep: true },
);

const Tldraw = mountReactComponent(TldrawReactWrapper);

const updateModel = (newData: any) => {
  emit('update:modelValue', newData);
  emit('update:data', newData);
};
</script>

<style scoped>
.tldraw-wrapper >>> .tlui-helper-buttons {
  left: 4rem;
  top: 1rem;
  margin-top: 0;
}

:deep(.tl-rich-text p) {
  display: unset;
  font-size: inherit !important;
  line-height: inherit !important;
  color: inherit !important;
}

:deep(.tl-text-wrapper[data-font='draw']) {
  font-family: tldraw_draw, sans-serif !important;
}
:deep(.tl-text-wrapper[data-font='sans']) {
  font-family: tldraw_sans, sans-serif !important;
}
:deep(.tl-text-wrapper[data-font='serif']) {
  font-family: tldraw_serif, serif !important;
}
:deep(.tl-text-wrapper[data-font='mono']) {
  font-family: tldraw_mono, sans-monospace !important;
}

:root {
  --tl-font-draw: 'tldraw_draw', sans-serif;
  --tl-font-sans: 'tldraw_sans', sans-serif;
  --tl-font-serif: 'tldraw_serif', serif;
  --tl-font-mono: 'tldraw_mono', monospace;
}
</style>
